import React, { Children, useEffect, useState } from 'react'
import { useToggle } from '../../../../context/toggle/toggleBtn';
import { GenericOffCanvas } from '../../../common/OffCanvas/GenericOffCanvas';
import { MenuList } from './Menu-list/MenuList';
import { SessionCanva } from './Responsive-Session-Canva/SessionCanva';
import { BottomSheetBeta } from '../../../common/bottom-sheet/BottomSheetBeta';
import { BottomSheetAnimate } from '../../../common/bottom-sheet-animate/BottomSheetAnimate';



export const HeaderMain = ({ enableMenu = true }) => {


    //? bottom Sheet State

    const [BottomSheet, setBottomSheet] = useState(false);

    const openBottomSheet = () => setBottomSheet(true)
    const closeBottomSheet = () => setBottomSheet(false)


    const { toggleBTN, toggleClose, isActive, callerElementId } = useToggle()



    // useEffect(() => {
    //     if (callerElementId === 2) {
    //         openBottomSheet()
    //     }
    // }, [callerElementId])

    return (

        <>
            <header className="header-main">

                <div role='button' className='header-main-menu-icon d-flex'>
                    <span
                        // className="material-symbols-outlined mI-User mp-mI-U2 notranslate"
                        className={`material-symbols-outlined mI-User mp-mI-U2 notranslate ${!enableMenu ? 'disabledMenu' : ''}`}
                        aria-hidden="true" role="none"
                        onClick={(e) => toggleBTN(Number(e.currentTarget.dataset.id))}
                        data-id="1">
                        menu
                    </span>

                </div>
                {/* <span
                    // className="material-symbols-outlined mI-User mp-mI-U2 notranslate"
                    className={`material-symbols-outlined mI-User mp-mI-U2 notranslate ${!enableMenu ? 'disabledMenu' : ''}`}
                    aria-hidden="true" role="none"
                    onClick={(e) => toggleBTN(Number(e.currentTarget.dataset.id))}
                    data-id="1">
                    menu
                </span> */}

                <span
                    className="material-symbols-outlined mI-User mI-U2 notranslate modalSesionClose"
                    aria-hidden="true"

                    onClick={(e) => {
                        toggleBTN(Number(e.currentTarget.dataset.id));
                        openBottomSheet()
                    }}
                    data-id="2"
                    role="button"
                >
                    account_circle
                </span>


            </header>

            {/* <GenericOffCanvas placement={'start'}/> */}
            {callerElementId === 1 && enableMenu ?
                <GenericOffCanvas
                    placement={'start'}
                    OCStyle={'offCanvas-width'}
                    closeButton={true}>
                    <MenuList />
                </GenericOffCanvas>
                : callerElementId === 2 ?
                    // <GenericOffCanvas
                    //     placement={'bottom'}
                    //     OCStyle={'offCanvas-bottom'}
                    //     closeButton={false}
                    //     OCBodyStyle={'offCanvasBodyBottom'}
                    // >
                    //     <SessionCanva />
                    // </GenericOffCanvas>

                    <BottomSheetAnimate
                        bottomSheetStatus={BottomSheet}
                        closeBottomSheet={closeBottomSheet}
                    >
                        <SessionCanva />
                    </BottomSheetAnimate>

                    : null}

        </>

    )
}
